/** Loading placeholder shaped like the card, themed off the same card vars. */
export default function CardSkeleton({ aspectRatio }: { aspectRatio: string }) {
  return (
    <div className="hr-pc-card hr-pc-skeleton" role="img" aria-label="Loading property">
      <div className="hr-pc-skeleton__media" style={{ aspectRatio }} />
      <div className="hr-pc-body">
        <div className="hr-pc-skeleton__line hr-pc-skeleton__line--title" />
        <div className="hr-pc-skeleton__line hr-pc-skeleton__line--short" />
        <div className="hr-pc-skeleton__line hr-pc-skeleton__line--price" />
      </div>
    </div>
  )
}
